import styled from "styled-components"

import theme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import {Body, Label} from "@irati/ui/src/Typography"
import Icon from "@irati/ui/src/Icon"
import {TooltipLabel} from "../EnabledDisabledLabel"

interface StyledInfoProps {
  backgroundColor?: string
}

interface StyledLabelProps {
  enabled: boolean
  tooltip?: TooltipLabel
}

export const InfoCard = styled(Flex)<StyledInfoProps>`
  background-color: ${({backgroundColor}) => backgroundColor || `${theme.colors.utility.highlight}`};
  border-radius: ${theme.border.radius.large};
`

export const LinkCard = styled(Flex)`
  height: ${theme.spacing.eight};
  margin-bottom: ${theme.spacing.three};
  background-color: ${theme.colors.utility.highlight};
  border-radius: ${theme.border.radius.medium};
  border: 1px solid ${theme.colors.utility.contrast};
`

export const StyledLink = styled(Body)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 175px);
`

export const StyledLabel = styled(Label)<StyledLabelProps>`
  border-radius: ${theme.spacing.half};
  padding: ${`${theme.spacing.one} ${theme.spacing.two}`};
  color: ${({enabled}) => (enabled ? theme.colors.greys.white : theme.colors.utility.ink)};
  background-color: ${({enabled}) => (enabled ? theme.colors.tertiary.g_400 : theme.colors.greys.light)};
  cursor: ${({enabled, tooltip}) => ((enabled && tooltip?.enabled) || (!enabled && tooltip?.disabled) ? "pointer" : "default")};
`

export const StyledIcon = styled(Icon)`
  path:last-child {
    fill: ${theme.colors.tertiary.y_400};
  }
`
